import { motion } from "framer-motion";
import { SITE } from "../config";

const fade = {
  hidden: { opacity: 0, y: 40 },
  show: (i = 0) => ({ opacity: 1, y: 0, transition: { duration: 0.9, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] } }),
};

export const BookShowcase = () => {
  return (
    <section id="book" data-testid="book-section" className="relative py-24 md:py-40 max-w-[1600px] mx-auto px-6 md:px-12">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
        {/* Sticky cover */}
        <div className="lg:col-span-5">
          <div className="lg:sticky lg:top-28">
            <motion.div
              variants={fade}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, amount: 0.3 }}
              data-testid="book-cover"
              className="cover-crop gold-glow w-full max-w-[420px] aspect-[7/10] mx-auto"
              style={{ "--cover": `url(${SITE.coverImage})` }}
            />
          </div>
        </div>

        {/* Details */}
        <div className="lg:col-span-7">
          <motion.p variants={fade} initial="hidden" whileInView="show" viewport={{ once: true }} className="font-grotesk uppercase tracking-[0.35em] text-xs text-[#d8ab4e] mb-6">
            About the Book
          </motion.p>
          <motion.h2 variants={fade} custom={1} initial="hidden" whileInView="show" viewport={{ once: true }} className="font-display text-4xl sm:text-6xl leading-[0.95] mb-10">
            A guide to <span className="gold-text italic">navigating</span> the future.
          </motion.h2>

          {SITE.blurb.map((p, i) => (
            <motion.p
              key={i}
              variants={fade}
              custom={2 + i}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
              className="font-body text-lg md:text-xl text-[#c3b79b] leading-relaxed mb-7 max-w-2xl"
            >
              {p}
            </motion.p>
          ))}

          <motion.p variants={fade} custom={4} initial="hidden" whileInView="show" viewport={{ once: true }} className="font-display italic text-3xl sm:text-4xl gold-text mt-6 mb-12">
            {SITE.closing}
          </motion.p>

          <motion.div variants={fade} custom={5} initial="hidden" whileInView="show" viewport={{ once: true }} className="flex flex-wrap gap-6 items-center border-t border-[#d8ab4e]/15 pt-10">
            <a
              href={SITE.amazonUrl}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="book-buy-btn"
              className="group inline-flex items-center gap-3 bg-[#d8ab4e] text-[#0a0805] px-8 py-4 font-semibold uppercase tracking-widest hover:bg-[#f2c968] transition-colors"
            >
              {SITE.amazonLabel}
              <span className="inline-block transition-transform group-hover:translate-x-1.5">→</span>
            </a>
            <div className="text-sm">
              <p className="text-[#e7dcc2] font-semibold">Non-Fiction · Wealth & Legacy</p>
              <p className="text-[#7d7460] uppercase tracking-widest text-xs mt-1">Kindle eBook &amp; Paperback</p>
              <p className="text-[#7d7460] uppercase tracking-widest text-xs">Paperback ISBN {SITE.isbnPaperback}</p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default BookShowcase;
